import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import HomePage from "./components/HomePage";
import LoginForm from "./components/LoginForm";
import RegistrationForm from "./components/RegistrationForm";
import Header from "./components/Header";
import NewsList from "./components/NewsList";
import PostDetail from "./components/PostDetail";
import AboutPage from "./components/AboutPage";
import DonationDetails from "./components/DonationDetails";
import ProjectsPage from "./components/ProjectsPage";
import Team from "./components/Team";
import ProjectDetail from "./components/ProjectDetail";
import PartnersPage from "./components/PartnersPage";
import Cabinet from "./components/Cabinet";
import Footer from "./components/Footer";
import NotFoundPage from "./components/NotFoundPage";
import AdminApp from "./admin/AdminApp";
import "./App.css";

// Компонент для прокрутки страницы вверх при смене маршрута
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      <ScrollToTop />
      {!isAdminRoute && <Header />}
      <Routes>
        {/* Main site routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/signup" element={<RegistrationForm />} />
        <Route path="/news" element={<NewsList />} />
        <Route path="/news/:id" element={<PostDetail />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/donate" element={<DonationDetails />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/team" element={<Team />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/projects/:projectId" element={<ProjectDetail />} />
        <Route path="/cabinet" element={<Cabinet />} />

        {/* Admin routes */}
        <Route path="/admin/*" element={<AdminApp />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {!isAdminRoute && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
